<template>
  <div v-if="!isMobileVertical" class="header-body">
    <Logo />

    <div class="right-panel">
      <div class="bet-range">
        <span class="bet-range-label"> {{ $t('Max') }}:&nbsp;</span>
        <span> {{ formatAmountWithKM(mainLimitAmountPerFight, 0) }}</span>
        <div class="drop-down disable">
          <div class="drop-down-item">
            <img src="@/assets/svg/chart-icons/banker.svg" alt="Banker" />
            <img src="@/assets/svg/chart-icons/player.svg" alt="Player" />
            <span class="limit-text">{{ formatAmountWithKM(mainLimitAmountPerFight, 0) }}</span>
          </div>
          <div class="drop-down-item">
            <img class="draw-icon" src="@/assets/svg/chart-icons/draw.svg" alt="Draw" />
            <span class="limit-text">{{ formatAmountWithKM(drawLimitAmountPerFight, 0) }}</span>
          </div>
        </div>
      </div>
      <div class="menu">
        <div class="menu-item menu-lobby" @click.stop="redirectToLobby()" v-if="lobbyUrl">
          <img class="logo" :src="getImgUrl('lobby')" />
          <div class="text-label">{{ $t('Lobby') }}</div>
        </div>
        <div
          :class="['menu-item menu-history', { active: activePopupPage === PopupPage.history }]"
          @click.stop="openMenuPopup('History')"
        >
          <img class="logo" :src="getImgUrl('history')" />
          <div class="text-label">{{ $t('History') }}</div>
        </div>
        <div
          :class="['menu-item menu-help', { active: activePopupPage === PopupPage.help }]"
          @click.stop="openMenuPopup(PopupPage.help)"
        >
          <img class="logo" :src="getImgUrl('help')" />
          <div class="text-label">
            {{ $t('Help') }}
          </div>
        </div>
        <div class="menu-item menu-language">
          <LanguageDropdown />
        </div>
      </div>
      <div class="header-item">
        <div class="user" :class="{ 'cursor-pointer': withCommission }">
          <img src="@/assets/images/user.webp" />{{ memberName }}
          <div class="drop-down">
            <ToggleBtn
              :leftTxt="$t('Eu')"
              :rightTxt="$t('My')"
              :value="toggleValue"
              v-if="config.availableOddsType.length > 1"
              @toggle="(e) => toggleOdds(e)"
              class="drop-down-item"
            />
            <div v-if="withCommission" @click="logoutCreditUser()" class="drop-down-item">{{ $t('Logout') }}</div>
          </div>
        </div>
      </div>
      <div class="header-item relative">
        <div class="balance" :class="{ 'tooltip-container': isLargeBalance }">
          {{ currencySymbol }}
          <animated-amount
            :value="balance"
            :formatValue="isLargeBalance ? formatLargeAmount : formatAmount"
            :duration="500"
          />
          <span v-if="isLargeBalance" class="balance-tooltip"
            >{{ $t('Balance') }}: {{ currencySymbol }}{{ formatAmount(balance) }}</span
          >
        </div>
        <Transition name="fade">
          <div v-if="futureDiff" class="furture-diff">+ {{ userFutureDiff }}</div>
        </Transition>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { formatAmount, formatAmountWithKM, getImgUrl, formatLargeAmount } from '@/utils/helpers';
import { isMobile } from 'mobile-device-detect';
import LanguageDropdown from '@/components/menus/language-dropdown';
import { PopupPage } from '@/utils/index.model';
import Logo from '@/components/logo.vue';
import AnimatedAmount from '@/components/animated-amount.vue';
import ToggleBtn from '@/components/toggle-btn.vue';
import { initMgConnection } from '@/utils/websocket';

export default {
  components: {
    LanguageDropdown,
    AnimatedAmount,
    Logo,
    ToggleBtn,
  },
  data: () => {
    return {
      PopupPage,
    };
  },
  computed: {
    ...mapGetters({
      balance: 'general/balance',
      futureDiff: 'general/futureDiff',
      isPopupOpen: 'menu/isPopupOpen',
      activePopupPage: 'menu/activePopupPage',
      config: 'general/config',
      member: 'general/member',
      token: 'general/token',
      oddsType: 'general/oddsType',
      enableJackpot: 'general/enableJackpot',
      lobbyUrl: 'general/lobbyUrl',
      selectedArena: 'general/selectedArena',
    }),
    isMobileVertical() {
      return isMobile && this.$screen.width < this.$screen.height;
    },
    userFutureDiff() {
      return formatAmount(this.futureDiff, 2);
    },
    currencySymbol() {
      return this.member.currencySymbol;
    },
    memberName() {
      const name = this.member.displayName;
      return name.length > 12 ? `${name.substr(0, 12)}...` : name;
    },
    withCommission() {
      return this.config.withCommission;
    },
    toggleValue() {
      return this.oddsType === 'my';
    },
    isLargeBalance() {
      return Number(this.balance) > 99999999.99;
    },
    mainLimitAmountPerFight() {
      if (this.selectedArena && this.selectedArena.mainLimitAmountPerFight) {
        return Number(this.selectedArena.mainLimitAmountPerFight) < Number(this.config.mainLimitAmountPerFight)
          ? Number(this.selectedArena.mainLimitAmountPerFight)
          : Number(this.config.mainLimitAmountPerFight);
      }
      return Number(this.config.mainLimitAmountPerFight);
    },
    drawLimitAmountPerFight() {
      if (this.selectedArena && this.selectedArena.drawLimitAmountPerFight) {
        return Number(this.selectedArena.drawLimitAmountPerFight) < Number(this.config.drawLimitAmountPerFight)
          ? Number(this.selectedArena.drawLimitAmountPerFight)
          : Number(this.config.drawLimitAmountPerFight);
      }
      return Number(this.config.drawLimitAmountPerFight);
    },
  },
  methods: {
    ...mapActions('menu', ['updateMenu']),
    ...mapActions('general', ['updateBalancefutureDiff', 'updateOddsType']),
    formatAmount,
    formatLargeAmount,
    getImgUrl,
    formatAmountWithKM,
    openMenuPopup(page) {
      this.updateMenu({ isPopupOpen: true, isJackpotPopupOpen: false, activePopupPage: page });
    },
    testWalletAnimation() {
      this.updateBalancefutureDiff(10000);
    },
    logoutCreditUser() {
      if (window.parent) {
        window.parent.postMessage('Logout', '*');
      }
    },
    toggleOdds(val) {
      const updatedOdds = this.config.availableOddsType[val ? 1 : 0];
      this.updateOddsType(updatedOdds);
      initMgConnection(this.token, updatedOdds);
    },
    redirectToLobby() {
      window.location.href = this.lobbyUrl;
    },
  },
};
</script>
<style lang="scss" scoped>
.header-body {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 8px;
  height: 90px;
  box-sizing: border-box;
  background-color: #051020;
  width: 100%;
  z-index: 50001;

  img.logo {
    height: 52px;
  }

  .right-panel {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;

    > div {
      margin-left: 16px;
    }

    .bet-range {
      
      font-size: 16px;
      text-align: left;
      color: #fff;
      text-transform: uppercase;
      padding: 0 12px;
      box-sizing: border-box;
      border-right: 1px solid #5b86af;
      position: relative;
      @include alignJustifyCenter;

      &-label {
        color: #b2d6ea;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;

        img {
          width: 16px;
          height: 16px;
          margin-right: 4px;
        }
      }

      &:hover .drop-down {
        display: block;
      }
    }

    .menu {
      display: flex;
      flex-direction: row;
      font-size: 16px;
      text-align: left;
      color: #fff;

      img {
        width: 32px;
        height: 32px;
        margin-right: 4px;
      }

      &-item {
        display: flex;
        flex-direction: row;
        @include alignJustifyCenter;
        cursor: pointer;
        margin-left: 12px;
        text-transform: uppercase;

        &.active {
          color: #ceb57d;
        }
      }
    }

    .header-item {
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: space-between;

      .tooltip-container {
        cursor: pointer;

        .balance-tooltip {
          opacity: 0;
          background: #102741;
          color: #fcc751;
          text-align: center;
          border-radius: 6px;
          padding: 5px 0;
          position: absolute;
          z-index: 1;
          top: 120%;
          margin-left: -75px;
          padding: 10px;
          transition: opacity 0.2s;
          line-height: 1.5;
          pointer-events: none;

          &::after {
            content: '';
            position: absolute;
            bottom: 100%;
            left: 50%;
            margin-left: -5px;
            border-width: 5px;
            border-style: solid;
            border-color: transparent transparent #102741 transparent;
            cursor: default;
          }
        }

        &:hover .balance-tooltip {
          opacity: 1;
        }
      }

      .balance {
        font-size: 16px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        color: #fcc751;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        font-feature-settings: 'tnum' on, 'lnum' on;
      }

      .furture-diff {
        position: absolute;
        top: 100%;
        left: 0;
        font-size: 16px;
        font-weight: 600;
        color: #ffefcc;
      }

      .user {
        font-size: 16px;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        color: #fff;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        position: relative;
        height: 100%;

        &.cursor-pointer {
          cursor: pointer;
        }

        img {
          height: 24px;
          width: 24px;
          margin-right: 5px;
        }

        &:hover .drop-down {
          display: block;
        }
      }

      .burger-menu {
        width: 32px;
        height: 32px;
      }
    }
    @include dropDown;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 2s ease;
}

.fade-enter-from {
  opacity: 0;
  top: 100%;
}
.fade-leave-to {
  opacity: 0;
  top: 0;
}
</style>
